const originalFetch = window.fetch;
window.fetch = function () {
    const url = arguments[0];
    return originalFetch.apply(this, arguments)
        .then(function (response) {
            if (response.url.includes('/cart/change') || response.url.includes('/cart/add')) {
            setTimeout(() => {
                tScartScript();
            }, 500);
            }
            return response;
        });
};

function tScartScript() {
    // Cart drawer eltávolítása a /cart oldalon
    const isCartPage = window.location.pathname === '/cart';
    
    if (isCartPage) {
        const cartDrawer = document.querySelector('.cart-drawer');
        if (cartDrawer) {
            cartDrawer.remove();
        }
    }

    // Cart attributes lekérése és adószám beállítása
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            if (cart.attributes && cart.attributes.tax_number) {
                const taxInputs = document.querySelectorAll('#taxnumber');
                taxInputs.forEach(input => {
                    input.value = cart.attributes.tax_number;
                    // Ha van érték, mutassuk meg az adószám mezőt
                    const container = input.closest('.cart-drawer, .cart-footer');
                    const taxNumberContainer = container.querySelector('.show_tax_number');
                    if (taxNumberContainer) {
                        taxNumberContainer.style.display = 'block';
                    }
                });
            }
        })
        .catch(error => console.error('Error loading cart:', error));

    console.log('validateTerms');
    const checkoutButtons = document.querySelectorAll('button[name="checkout"]');

    // Hozzáadjuk a checkbox változás figyelését
    document.querySelectorAll('#show_cart_terms').forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            const container = this.closest('.cart-drawer, .cart-footer');
            const errorBanner = container.querySelector('.banner-error-terms');
            if (errorBanner) {
                errorBanner.style.display = this.checked ? 'none' : 'block';
            }
        });
    });

    if (checkoutButtons.length) {
        checkoutButtons.forEach(button => {
            button.addEventListener('click', function(event) {
                const cartContainer = button.closest('.cart-drawer, .cart-footer');
                const termsCheckbox = cartContainer.querySelector('#show_cart_terms');
                const errorBanner = cartContainer.querySelector('.banner-error-terms');
                const taxInput = cartContainer.querySelector('#taxnumber');
                const taxErrorDiv = cartContainer.querySelector('#taxNumberError');
                
                // Először ellenőrizzük a checkbox-ot
                if (termsCheckbox && !termsCheckbox.checked) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (errorBanner) {
                        errorBanner.style.cssText = `
                            display: block !important;
                            visibility: visible !important;
                            opacity: 1 !important;
                            position: relative !important;
                            z-index: 1000 !important;
                            margin: 10px 0 !important;
                        `;
                        errorBanner.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                    return;
                }

                // Majd ellenőrizzük az adószámot, ha ki van töltve
                if (taxInput && taxInput.value.trim().length > 0) {
                    if (!validateHungarianTaxNumber(taxInput.value)) {
                        event.preventDefault();
                        event.stopPropagation();
                        if (taxErrorDiv) {
                            taxErrorDiv.style.cssText = `
                                display: block !important;
                                visibility: visible !important;
                                opacity: 1 !important;
                            `;
                            taxErrorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                        return;
                    }
                }

                // Ha minden rendben, elrejtjük az error üzeneteket
                if (errorBanner) errorBanner.style.display = 'none';
                if (taxErrorDiv) taxErrorDiv.style.display = 'none';
            });
        });
    }

    // Megtartjuk az eredeti tax number validációs funkciókat
    initializeTaxNumberValidation();
}

function initializeTaxNumberValidation() {
    const addTaxNumberLinks = document.querySelectorAll('.add_tax_number a, .add_tax_number .link');
    
    if (addTaxNumberLinks) {
        addTaxNumberLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                console.log('Tax number link clicked');
                
                const container = this.closest('.cart-drawer, .cart-footer');
                const taxNumberContainer = container.querySelector('.show_tax_number');
                
                if (taxNumberContainer) {
                    taxNumberContainer.style.display = 'block';
                }
            });
        });
    }
}

// Adószám formázás és validáció függvények
function formatTaxNumber(value) {
    value = value.replace(/[^\d-]/g, '');
    
    if (value.includes('-')) {
        return value.slice(0, 13);
    }
    
    value = value.replace(/[^\d]/g, '');
    if (value.length > 8) {
        value = value.slice(0, 8) + '-' + value.slice(8);
    }
    if (value.length > 10) {
        value = value.slice(0, 10) + '-' + value.slice(10);
    }
    return value.slice(0, 13);
}

function validateHungarianTaxNumber(taxNumber) {
    // Eltávolítjuk a whitespace-t az elejéről és végéről
    taxNumber = taxNumber.trim();
    
    // Ellenőrizzük a formátumot: 12345678-1-23
    const taxNumberPattern = /^\d{8}-[1-5]-\d{2}$/;
    
    // Ha nem felel meg a mintának, visszatérünk false-szal
    if (!taxNumberPattern.test(taxNumber)) {
        return false;
    }

    // Ha megfelel a mintának, további ellenőrzések
    const parts = taxNumber.split('-');
    const vatCode = parseInt(parts[1]);
    const areaCode = parseInt(parts[2]);

    // Ellenőrizzük a részeket
    if (vatCode < 1 || vatCode > 5) return false;
    if (areaCode < 0 || areaCode > 99) return false;

    return true;
}

document.addEventListener('DOMContentLoaded', function() {
  tScartScript();
});


